export const firebaseUserSelector = (state) => state.vs_user.firebaseUser;
export const spannerUserIdSelector = (state) => state.vs_user.spannerUserId;
export const depotUserListSelector = (state) => state.vs_user.depotUserList;
